<template>
  <div class="frame-wrapper16">
    <div class="methodology-box">
      <div class="thats-why-we-created-monglis-parent">
        <div class="thats-why-we-created-monglis-parent">
          <div class="thats-why-we-container">
            <p class="join">
              <span><b>{{ t('immersion_methodology.thats_why') }}</b></span>
              <span class="students"><b>{{ t('immersion_methodology.immersive_learning') }}</b></span>
            </p>
          </div>
          <div class="the-only-approach-container">
            <p class="join">{{ t('immersion_methodology.only_approach') }}</p>
          </div>
        </div>
        <div class="frame-wrapper17">
          <div class="frame-parent17">
            <div class="frame-wrapper18" :class="{ rtl: locale === 'ar' }">
              <div class="icon-parent">
                <img class="icon" src="@/assets/imm/fun.svg" alt="Fun clubs" />
                <div class="your-child-joins" v-html="t('immersion_methodology.point1')"></div>
              </div>
            </div>
            <div class="frame-wrapper18" :class="{ rtl: locale === 'ar' }">
              <div class="icon-group">
                <img class="icon" src="@/assets/imm/engage.svg" alt="Active engagement" />
                <div class="your-child-joins">{{ t('immersion_methodology.point2') }}</div>
              </div>
            </div>
            <div class="frame-wrapper20" :class="{ rtl: locale === 'ar' }">
              <div class="icon-container">
                <img class="icon3" src="@/assets/imm/teach.svg" alt="Expert instructors" />
                <div class="your-child-joins">{{ t('immersion_methodology.point3') }}</div>
              </div>
            </div>
            <div class="frame-wrapper21" :class="{ rtl: locale === 'ar' }">
              <div class="icon-parent2">
                <img class="icon" src="@/assets/imm/learn.svg" alt="Small group learning" />
                <div class="your-child-joins">{{ t('immersion_methodology.point4') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="that-means-your" v-html="t('immersion_methodology.conclusion')"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useLanguage } from '@/composables/useLanguage'

const { t, locale } = useLanguage()
</script>

<style scoped>
.frame-wrapper16 {
  width: 100%;
  max-width: 100vw;
  background-color: var(--bg-light);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: clamp(30px, 5vw, 60px) clamp(15px, 3vw, 20px);
  box-sizing: border-box;
  color: var(--color-title);
}

/* RTL specific - Reduced padding */
html[lang="ar"] .frame-wrapper16 {
  padding: 30px 15px;
}

.methodology-box {
  width: 100%;
  max-width: 1460px;
  background: rgba(250, 222, 190, 0.10);
  border: 1px solid #AEAEAE;
  border-radius: 24px;
  padding: clamp(40px, 5vw, 60px) clamp(30px, 4vw, 60px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.thats-why-we-created-monglis-parent {
  width: 100%;
  max-width: 1760px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}

/* RTL specific - Reduced gap */
html[lang="ar"] .thats-why-we-created-monglis-parent {
  gap: 20px;
}

.thats-why-we-container {
  max-width: 1716px;
  width: 100%;
  line-height: 130%;
  text-transform: uppercase;
  opacity: 0.9;
  text-align: center;
  font-size: clamp(32px, 3.8vw, 54px);
  padding: 0 clamp(10px, 2vw, 20px);
  box-sizing: border-box;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

.join {
  margin: 0;
  word-break: keep-all;
  white-space: normal;
  font-size: inherit;
  line-height: inherit;
}

.students {
  color: var(--color-primary);
}

.methodology {
  color: var(--color-title);
}

.the-only-approach-container {
  max-width: 1127px;
  width: 100%;
  font-size: clamp(20px, 2.2vw, 32px);
  line-height: 160%;
  color: var(--color-title);
  opacity: 0.9;
  text-align: center;
  padding: 0 clamp(10px, 2vw, 20px);
  box-sizing: border-box;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.frame-wrapper17 {
  width: 100%;
  max-width: 1461px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
  font-size: 20px;
}

.frame-parent17 {
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: clamp(15px, 2vw, 18px);
  flex-wrap: wrap;
}

.frame-wrapper18,
.frame-wrapper20,
.frame-wrapper21 {
  flex: 1;
  min-width: 260px;
  max-width: 353px;
  width: 100%;
  box-shadow: 0px 3px 17px rgba(0, 0, 0, 0.07);
  backdrop-filter: blur(14px);
  border-radius: clamp(14px, 2.5vw, 17px);
  background-color: var(--bg-card);
  border: 1px solid var(--border-light);
  box-sizing: border-box;
  padding: clamp(24px, 5vw, 40px) clamp(20px, 4vw, 32px);
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

/* RTL specific - Reduced padding */
html[lang="ar"] .frame-wrapper18,
html[lang="ar"] .frame-wrapper20,
html[lang="ar"] .frame-wrapper21 {
  padding: 20px 16px;
}

.frame-wrapper18:hover,
.frame-wrapper20:hover,
.frame-wrapper21:hover {
  transform: translateY(-5px);
  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.12);
}

.icon-parent,
.icon-group,
.icon-container,
.icon-parent2 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

/* RTL specific - Reduced gap */
html[lang="ar"] .icon-parent,
html[lang="ar"] .icon-group,
html[lang="ar"] .icon-container,
html[lang="ar"] .icon-parent2 {
  gap: 8px;
}

.icon,
.icon3 {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.your-child-joins {
  line-height: 160%;
  font-weight: 500;
  color: var(--color-title);
  font-size: clamp(15px, 2.5vw, 18px);
  width: 100%;
}

.that-means-your {
  max-width: 1052px;
  width: 100%;
  font-size: clamp(18px, 1.6vw, 24px);
  letter-spacing: -0.02em;
  line-height: 160%;
  text-transform: uppercase;
  font-weight: 500;
  opacity: 0.9;
  text-align: center;
  padding: 0 clamp(15px, 3vw, 20px);
  box-sizing: border-box;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

@media (max-width: 1200px) {
  .frame-wrapper16 {
    padding: 60px 20px;
  }

  .frame-parent17 {
    gap: 15px;
  }
}

@media (max-width: 768px) {
  .frame-wrapper16 {
    padding: clamp(30px, 5vw, 40px) clamp(15px, 3vw, 20px);
  }

  .thats-why-we-created-monglis-parent {
    gap: clamp(25px, 4vw, 30px);
  }

  .thats-why-we-container {
    font-size: clamp(26px, 4.2vw, 38px);
    line-height: 145%;
    padding: 0 clamp(15px, 3vw, 20px);
  }

  .the-only-approach-container {
    font-size: clamp(18px, 2.8vw, 26px);
    line-height: 170%;
    padding: 0 clamp(15px, 3vw, 20px);
  }

  .that-means-your {
    font-size: clamp(16px, 2.4vw, 22px);
    line-height: 170%;
    padding: 0 clamp(15px, 3vw, 20px);
  }

  .frame-parent17 {
    flex-direction: column;
    align-items: center;
  }

  .frame-wrapper18,
  .frame-wrapper20,
  .frame-wrapper21 {
    max-width: 100%;
    width: 100%;
    padding: clamp(28px, 5vw, 32px) clamp(20px, 4vw, 24px);
  }

  .your-child-joins {
    text-align: center;
  }
}

@media (max-width: 640px) {
  .frame-wrapper16 {
    padding: clamp(25px, 4.5vw, 35px) clamp(15px, 3vw, 18px);
  }

  .thats-why-we-container {
    font-size: clamp(24px, 4.5vw, 32px);
    line-height: 150%;
    padding: 0 clamp(15px, 3.5vw, 20px);
    word-spacing: 0.1em;
  }

  .the-only-approach-container {
    font-size: clamp(17px, 3.2vw, 22px);
    line-height: 180%;
    padding: 0 clamp(15px, 3.5vw, 20px);
    word-spacing: 0.05em;
  }

  .that-means-your {
    font-size: clamp(15px, 3vw, 19px);
    line-height: 180%;
    padding: 0 clamp(15px, 3.5vw, 20px);
    word-spacing: 0.05em;
  }
}

@media (max-width: 480px) {
  .frame-wrapper16 {
    padding: clamp(20px, 4vw, 30px) clamp(15px, 3.5vw, 18px);
  }

  .frame-wrapper18,
  .frame-wrapper20,
  .frame-wrapper21 {
    padding: clamp(20px, 4vw, 24px) clamp(16px, 3vw, 20px);
  }

  .thats-why-we-container {
    padding: 0 clamp(15px, 3.8vw, 18px);
    font-size: clamp(18px, 4.8vw, 22px);
    line-height: 155%;
    word-spacing: 0.15em;
    letter-spacing: 0.02em;
  }

  .the-only-approach-container {
    padding: 0 clamp(15px, 3.8vw, 18px);
    font-size: clamp(13px, 3.5vw, 15px);
    line-height: 190%;
    word-spacing: 0.1em;
    letter-spacing: 0.01em;
  }

  .that-means-your {
    padding: 0 clamp(15px, 3.8vw, 18px);
    font-size: clamp(13px, 3.8vw, 16px);
    line-height: 190%;
    word-spacing: 0.1em;
    letter-spacing: 0.01em;
  }
}

@media (max-width: 380px) {
  .frame-wrapper16 {
    padding: 20px 15px;
  }

  .frame-wrapper18,
  .frame-wrapper20,
  .frame-wrapper21 {
    padding: 18px 14px;
    min-width: 240px;
  }

  .thats-why-we-container {
    padding: 0 15px;
    font-size: 17px;
    line-height: 160%;
    word-spacing: 0.2em;
    letter-spacing: 0.03em;
  }

  .the-only-approach-container {
    padding: 0 15px;
    font-size: 12.5px;
    line-height: 200%;
    word-spacing: 0.15em;
    letter-spacing: 0.02em;
  }

  .that-means-your {
    padding: 0 15px;
    font-size: 12.5px;
    line-height: 200%;
    word-spacing: 0.15em;
    letter-spacing: 0.02em;
  }
}

/* RTL styles for Arabic */
.frame-wrapper18.rtl,
.frame-wrapper20.rtl,
.frame-wrapper21.rtl {
  direction: rtl;
  text-align: right;
}

.rtl .icon-parent,
.rtl .icon-group,
.rtl .icon-container,
.rtl .icon-parent2 {
  align-items: flex-start;
}

.rtl .your-child-joins {
  text-align: right;
}
</style>
